import { TRootState } from "../@types/redux";

export const selectIsUpdateRecipesCategory = (state: TRootState) =>
  state.recipesCategories.isUpdateRecipesCategory;

export const selectRecipesCategoryForUpdate = (state: TRootState) =>
  state.recipesCategories.recipesCategoriesForUpdate;

export const selectRecipesCategoriesRefreshTable = (state: TRootState) =>
  state.recipesCategories.refreshTableRecipesCategories;

export const selectModalRecipesCategories = (state: TRootState) =>
  state.recipesCategories.recipesCategoriesModalIsOpen;
